import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/exceptions/exceptions-settings/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      app: APP_PATHS.VULNERABILITIES,
      path: PAGE_PATHS.EXCEPTIONS_SETTINGS,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
